import React, { useEffect, useState } from 'react';
import { Heart, MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import ProfilePhoto from './ProfilePhoto';
import { apiService } from '../services/api';

// Shown after the swipe API confirms a mutual match. Purely presentational: it never creates or mutates matches.
const MatchCelebration = ({ match, onSayHi, onClose }) => {
  const [myPhoto, setMyPhoto] = useState(null);

  useEffect(() => {
    apiService.users.getMe()
      .then((r) => setMyPhoto((r.data?.data?.images || [])[0] || null))
      .catch(() => setMyPhoto(null));
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!match) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={onClose} data-testid="match-celebration">
      <div
        className="relative w-full max-w-sm rounded-3xl bg-gradient-to-b from-rose-600 via-pink-600 to-orange-500 p-6 sm:p-8 text-center text-white shadow-2xl animate-in fade-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} className="absolute right-4 top-4 rounded-full bg-white/15 p-2 hover:bg-white/25" aria-label="Close" data-testid="match-celebration-close">
          <X className="h-5 w-5" />
        </button>

        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/80">Mutual like</p>
        <h2 className="mt-1 text-4xl sm:text-5xl font-black leading-none drop-shadow" data-testid="match-celebration-title">It's a Match!</h2>
        <p className="mt-3 text-sm text-white/90" data-testid="match-celebration-text">
          You and <span className="font-semibold">{match.name}</span> liked each other.
        </p>

        <div className="mt-7 flex items-center justify-center">
          <div className="h-28 w-28 sm:h-32 sm:w-32 rounded-full border-4 border-white shadow-xl overflow-hidden -mr-4 rotate-[-6deg] bg-white" data-testid="match-celebration-my-photo">
            <ProfilePhoto src={myPhoto} alt="You" compact />
          </div>
          <div className="z-10 rounded-full bg-white p-2.5 shadow-lg">
            <Heart className="h-6 w-6 fill-rose-500 text-rose-500" />
          </div>
          <div className="h-28 w-28 sm:h-32 sm:w-32 rounded-full border-4 border-white shadow-xl overflow-hidden -ml-4 rotate-[6deg] bg-white" data-testid="match-celebration-their-photo">
            <ProfilePhoto src={match.image} alt={match.name} compact />
          </div>
        </div>

        <div className="mt-8 space-y-3">
          <Button onClick={onSayHi} className="w-full rounded-full bg-white text-rose-600 hover:bg-rose-50 font-bold text-base py-6" data-testid="match-celebration-say-hi">
            <MessageCircle className="mr-2 h-5 w-5" /> Say hi to {match.name.split(' ')[0]}
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full rounded-full text-white hover:bg-white/15 hover:text-white" data-testid="match-celebration-keep-swiping">
            Keep swiping
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MatchCelebration;
